import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { HelmetProvider } from 'react-helmet-async'; // ✅ Import HelmetProvider
import './i18n';
import './brand-blue.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider> 
      <Router>
        <Analytics />
        <App />
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
